import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Rx'
import { TestDefinition } from '../../models'
import { OperationServiceAdapter } from '../operation'
import { JsonApiProcessor } from '../operation/operation-processors'

export class TestDefinitionService extends OperationServiceAdapter<TestDefinition>{
  constructor(
    _processor: JsonApiProcessor
  ){
    super(_processor, TestDefinition)
  }

  public preview(testDefinition: {}):Observable<TestDefinition>{
    return this.callPostOperation('preview', testDefinition) as Observable<TestDefinition>
  }

  public save(testDefinition: TestDefinition):Observable<TestDefinition>{
    return this.callPostOperation('save', this._formatTestDefinition(testDefinition), ['testExecutions']) as Observable<TestDefinition>
  }

  public retry(testDefinition: TestDefinition):Observable<TestDefinition>{
    return this.callPostOperation('retry', this._formatTestDefinition(testDefinition), ['testExecutions']) as Observable<TestDefinition>
  }

  public edit(testDefinition: TestDefinition):Observable<TestDefinition>{
    return this.callPostOperation('edit', this._formatTestDefinition(testDefinition)) as Observable<TestDefinition>
  }

  public findAll():Observable<TestDefinition[]>{
    return this.callGetOperation('index', {},['testExecutions.testExecutionResults'] ) as Observable<TestDefinition[]>
  }

  public deactivate(testDefinition: TestDefinition):Observable<TestDefinition>{
    return this.callPostOperation('deactivate', this._formatTestDefinition(testDefinition)) as Observable<TestDefinition>
  }

  private _formatTestDefinition(testDefinition: TestDefinition) {
    return {testDefinition: testDefinition.toJson()}
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/test-definition/test-definition.service.ts